import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=63c74545&scoped=true&"
import script from "./ModalPopup.vue?vue&type=script&lang=js&"
export * from "./ModalPopup.vue?vue&type=script&lang=js&"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&id=63c74545&prod&lang=scss&"
import style1 from "./ModalPopup.vue?vue&type=style&index=1&id=63c74545&prod&lang=scss&scoped=true&"
import style2 from "./ModalPopup.vue?vue&type=style&index=2&id=63c74545&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c74545",
  null
  
)

export default component.exports